export enum BooleanType {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
}
